module.exports = __webpack_public_path__ + "static/media/SDS.556b46f1.png";